export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-foreground-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-10 md:pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-2">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
              className="inline-flex items-center gap-2 text-xl font-heading font-bold text-background-50 hover:text-primary-400 transition-colors cursor-pointer"
            >
              <span className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center text-sm font-bold text-background-50">
                718
              </span>
              黑料718
            </a>
            <p className="text-sm text-background-400 mt-4 leading-relaxed max-w-[360px]">
              专注于正能量黑料内容精选与传播的独立平台。发现爆料圈中的温暖故事与积极黑料，让每一次浏览都成为心灵的充电。重新定义黑料，传递正能量。
            </p>
            <div className="flex items-center gap-4 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-video-line'].map((icon, i) => (
                <a
                  key={i}
                  href="#footer"
                  className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-5">
              <i className="ri-compass-3-line mr-1.5"></i>快速导航
            </h4>
            <div className="space-y-3">
              {[
                { label: '专题索引', href: '#index' },
                { label: '热门话题', href: '#topics' },
                { label: '黑料热榜', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-5">
              <i className="ri-stack-line mr-1.5"></i>内容板块
            </h4>
            <div className="space-y-3">
              {[
                '明星正能量',
                '社会暖心',
                '职场励志',
                '公益行动',
                '校园正能量',
              ].map((label) => (
                <a
                  key={label}
                  href="#topics"
                  onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
                  className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-5">
              <i className="ri-links-line mr-1.5"></i>合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。如有合作意向，欢迎通过"联系我们"模块与我们取得联系，我们期待与优秀的内容创作者、公益组织和品牌方携手同行。
            </p>
          </div>
        </div>

        <div className="mt-12 md:mt-14 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2025-2026 黑料718 版权所有 · 正能量黑料内容精选平台 · 重新定义黑料的价值标准
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('#about'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
          </div>
        </div>
      </div>
    </footer>
  );
}